import { render, staticRenderFns } from "./shippings.vue?vue&type=template&id=4b2635a4&scoped=true"
import script from "./shippings.vue?vue&type=script&lang=js"
export * from "./shippings.vue?vue&type=script&lang=js"
import style0 from "./shippings.vue?vue&type=style&index=0&id=4b2635a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2635a4",
  null
  
)

export default component.exports